// birdeyeApi.js - Using CoinGecko for live price
const ARENA_TOKEN_ADDRESS = 'HFqQ6xKTEyL2RSS7b8Ss5Sn4qgFqbL5b4rZmDhMhpkin';

export async function getArenaPrice() {
  try {
    // CoinGecko API v3 - Get price by contract address (Solana)
    const response = await fetch(
      `https://api.coingecko.com/api/v3/simple/token_price/solana?contract_addresses=${ARENA_TOKEN_ADDRESS}&vs_currencies=usd`
    );

    if (!response.ok) {
      throw new Error('Failed to fetch price from CoinGecko');
    }

    const data = await response.json();
    
    // CoinGecko returns the price with contract address as key
    if (data[ARENA_TOKEN_ADDRESS] && data[ARENA_TOKEN_ADDRESS].usd) {
      const price = data[ARENA_TOKEN_ADDRESS].usd;
      console.log('ARENA price from CoinGecko:', price);
      return price; // Price in USD
    }
    
    // If contract address doesn't work, try by coin ID
    const backupResponse = await fetch(
      'https://api.coingecko.com/api/v3/simple/price?ids=arena-token&vs_currencies=usd'
    );
    
    if (backupResponse.ok) {
      const backupData = await backupResponse.json();
      if (backupData['arena-token'] && backupData['arena-token'].usd) {
        const price = backupData['arena-token'].usd;
        console.log('ARENA price from CoinGecko (by ID):', price);
        return price;
      }
    }
    
    throw new Error('ARENA token price not found on CoinGecko');
  } catch (error) {
    console.error('Error fetching ARENA price:', error);
    
    // Fallback to Jupiter API
    try {
      const jupiterResponse = await fetch(
        `https://price.jup.ag/v4/price?ids=${ARENA_TOKEN_ADDRESS}`
      );
      
      if (jupiterResponse.ok) {
        const jupiterData = await jupiterResponse.json();
        if (jupiterData.data && jupiterData.data[ARENA_TOKEN_ADDRESS]) {
          const price = jupiterData.data[ARENA_TOKEN_ADDRESS].price;
          console.log('ARENA price from Jupiter (fallback):', price);
          return price;
        }
      }
    } catch (jupiterError) {
      console.error('Jupiter fallback also failed:', jupiterError);
    }
    
    // Final fallback price
    console.log('Using fallback price: $0.001');
    return 0.001; // Default to $0.001 per ARENA
  }
}

export function calculateArenaAmount(usdAmount, arenaPrice) {
  // Calculate how many ARENA tokens needed for the USD amount
  // Add 1% buffer for price fluctuations
  const arenaAmount = (usdAmount / arenaPrice) * 1.01;
  return Math.ceil(arenaAmount); // Round up to ensure enough tokens
}

// Optional: Function to get detailed price info
export async function getArenaPriceDetails() {
  try {
    const response = await fetch(
      `https://api.coingecko.com/api/v3/coins/solana/contract/${ARENA_TOKEN_ADDRESS}`
    );
    
    if (response.ok) {
      const data = await response.json();
      return {
        price: data.market_data?.current_price?.usd || 0,
        priceChange24h: data.market_data?.price_change_percentage_24h || 0,
        marketCap: data.market_data?.market_cap?.usd || 0,
        volume24h: data.market_data?.total_volume?.usd || 0
      };
    }
  } catch (error) {
    console.error('Error fetching detailed price info:', error);
  }
  return null;
}
